import {Component, OnInit} from '@angular/core';
import {ModalController, Platform} from '@ionic/angular';
import {CallLog} from '@ionic-native/call-log/ngx';
import {CallModel} from '../../models/call.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {CustomerModel} from '../../models/customer.model';
import {ContactModel} from '../../models/contact.model';
import {DocumentModel} from '../../models/document.model';
import {NewDocumentService} from '../../services/new-document.service';
import {OpportunityPage} from '../opportunity/opportunity.page';


@Component({
    selector: 'app-call-log',
    templateUrl: './call-log.page.html',
    styleUrls: ['./call-log.page.scss'],
})
export class CallLogPage implements OnInit {
    callList: CallModel[];
    filters: any;
    recordsFound: any;
    recordsFoundText: string;
    customer: CustomerModel;
    customerList: any;
    contactList: ContactModel[];
    tempContactList: ContactModel[];
    document: DocumentModel;
    values = [1];

    constructor(private modalController: ModalController,
                private callLog: CallLog,
                private platform: Platform,
                private newDocumentService: NewDocumentService,
                private loki: LokijsService) {
    }

    ngOnInit() {
        this.initialize();
        console.log(this.callList);
        // const tempCall = new CallModel();
        // tempCall.number = '0876965183';
        // this.createOpp(tempCall);
    }

    cancelCallLog() {
        this.modalController.dismiss();
    }

    initialize() {
        this.platform.ready().then(() => {

            this.callLog.hasReadPermission().then(hasPermission => {
                if (!hasPermission) {
                    this.callLog.requestReadPermission().then(results => {
                        this.getContacts('type', '==');
                    })
                        .catch(e => alert(' requestReadPermission ' + JSON.stringify(e)));
                } else {
                    this.getContacts('type', '==');
                }
            })
                .catch(e => alert(' hasReadPermission ' + JSON.stringify(e)));
        });
    }

    getContacts(name, operator) {

        // Getting 5 Days Time
        const today = new Date();
        const daysEarlier = new Date(today);
        daysEarlier.setDate(today.getDate() - 5);
        const fromTime = daysEarlier.getTime();
        this.callList = [];
        for (const v of this.values) {
            this.filters = [{
                name: name,
                value: v,
                operator: operator,
            }, {
                name: 'date',
                value: fromTime.toString(),
                operator: '>=',
            }];
            this.callLog.getCallLog(this.filters)
                .then(results => {
                    this.recordsFoundText = JSON.stringify(results);
                    this.recordsFound = results; // JSON.stringify(results);
                    console.log(this.recordsFound);
                    if (results.length > 0) {
                        for (const result of this.recordsFound) {
                            this.callList.push(result);
                        }
                    }

                })
                .catch(e => alert(' LOG ' + JSON.stringify(e)));
            console.log(this.callList);
        }
    }

    createOpp(call: CallModel) {
        if (call.number) {
            let callNumb = call.number.split('').reverse().join('');
            callNumb = callNumb.substr(0, (callNumb.length < 7 ? callNumb.length : 7));
            callNumb = callNumb.split('').reverse().join('');
            const pat = /\d+/g;
            let tempPhone: any;
            let flatPhone: any;
            let matchPhone: any;
            this.contactList = this.loki.getTable('contact', '$loki').chain().data();
            this.tempContactList = [];
            for (const contact of this.contactList) {
                if (contact.phone) {
                    tempPhone = contact.phone.match(pat);
                    if (tempPhone) {
                        flatPhone = tempPhone.join('');
                        matchPhone = flatPhone.match(callNumb);
                        if (matchPhone) {
                            this.tempContactList.push(contact);
                        }
                    }
                }
            }
            console.log(this.tempContactList);
            if (this.tempContactList.length > 0) {
                this.populateCustomerList();
            } else {
                this.populateCustomerList(call);
            }
        }

    }

    populateCustomerList(call?: CallModel) {
        this.customerList = [];
        let customerTemp = new CustomerModel();
        for (const cont of this.tempContactList) {
            customerTemp = this.loki.getTable('customer', '$loki').chain().find({cod: cont.cust}).data()[0];
            this.customerList.push([customerTemp, cont]);
        }
        console.log(this.customerList);
        if (this.customerList.length > 0) {
            if (this.customerList.length === 1) {
                console.log('Exact Match');
                this.newDocument(this.customerList[0][0], this.customerList[0][1]);
            } else {
                console.log('Multiple Choice');
                this.newDocument(this.customerList[0][0], this.customerList[0][1]);
            }
        } else {
            const tempContact = new ContactModel();
            tempContact.name = call.name;
            tempContact.phone = call.number;
            this.newDocument(new CustomerModel(), tempContact);
        }
    }

    async newDocument(cust: CustomerModel, cont: ContactModel) {
        this.document = this.newDocumentService.genNewDocument();

        if (cust.name) {
            this.document.customer = cust;
        } else {
            this.document.customer = new CustomerModel();
        }
        if (cont.phone) {
            this.document.contact = cont;
        } else {
            this.document.contact = new ContactModel();
        }

        this.document.contact = cont;
        this.document.documentType = 15;
        const modal = await this.modalController.create({
            component: OpportunityPage,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document
            }
        });
        console.log(this.document);
        modal.onDidDismiss().then(_ => {

        });
        return await modal.present();
    }

    setStyle(type: number) {
        switch (type) {
            case 1:
                return ['arrow-back', 'green'];
                break;
            case 2:
                return ['arrow-forward', 'gray'];
                break;
            case 3:
                return ['close', 'red'];
                break;
            default:
            // code block
        }
    }
}
